  document.addEventListener("DOMContentLoaded", () => {
    // Function to adjust icon scaling
    function adjustIconScale(paymentScale = 1, policyScale = 1) {
      document.documentElement.style.setProperty(
        "--jovi-payment-icon-scale",
        paymentScale
      );
      document.documentElement.style.setProperty(
        "--jovi-policy-icon-scale",
        policyScale
      );
    }

    const paymentIcons = document.querySelectorAll(".jovi-payment-icon");
    const policyIconWrappers = document.querySelectorAll(
      ".jovi-policy-icon-wrapper"
    );

    paymentIcons.forEach((icon) => {
      icon.addEventListener("click", () => {
        console.log(`Payment icon clicked: ${icon.querySelector("img").alt}`);
      });
    });

    policyIconWrappers.forEach((wrapper) => {
      wrapper.addEventListener("click", () => {
        const title = wrapper.querySelector(".jovi-title").textContent;
        console.log(`Policy icon clicked: ${title}`);
      });
    });
  });